class PlatformUtil {
    // --------------   平台   ------------------
    static isMobile() {
        return /(mobile)/i.test(navigator.userAgent);
    }
    static isAndroid() {
        return /(android)/i.test(navigator.userAgent);
    }
    static isIOS() {
        return /(iphone|ipad|ipod)/i.test(navigator.userAgent);
    }
    static isIPad() {
        return /(ipad)/i.test(navigator.userAgent);
    }
    static isMac() {
        return !this.isMobile() && /Mac OS X/i.test(navigator.userAgent);
    }
    // --------------   浏览器   ------------------
    static isFireFox() {
        return /firefox/i.test(navigator.userAgent);
    }
    static isIE() {
        return (/msie/i.test(navigator.userAgent) && !this.isOpera()) || /trident/i.test(navigator.userAgent);
    }
    static isOpera() {
        return /opera/i.test(navigator.userAgent);
    }
    static isChrome() {
        return /chrome/i.test(navigator.userAgent);
    }
    static getChromeVersion() {
        const raw = /Chrom(e|ium)\/([0-9]+)\./.exec(navigator.userAgent);
        return raw ? parseInt(raw[2], 10) : 0;
    }
    // --------------   应用   ------------------
    // 移动端独立App
    static isTencentDocsApp() {
        // 注意：iOS 版携带了 'QQ'
        return /TencentDocs/i.test(navigator.userAgent);
    }
    /**
     * 是否是iPad端独立APP
     */
    static isTencentDocsIPadApp() {
        return this.isIPad() && this.isTencentDocsApp();
    }
    static isMiniProgram() {
        return /miniprogram|miniapp(?!enable)/i.test(navigator.userAgent)
            // eslint-disable-next-line @typescript-eslint/dot-notation
            || (typeof window['__wxjs_environment'] !== 'undefined' && window['__wxjs_environment'] === 'miniprogram');
    }
    static isWXMiniProgram() {
        return /MicroMessenger/i.test(navigator.userAgent) && this.isMiniProgram();
    }
    static isQQMiniProgram() {
        return /QQ\/|TIM/i.test(navigator.userAgent) && this.isMiniProgram();
    }
}

export { PlatformUtil };
//# sourceMappingURL=platform-utils.js.map
